<app-section-header
  [title]="'Resolve multiple changes'"
  [isBackBtnShown]="true"
  [backRoute]="['/dashboard']"
>
</app-section-header>
<div *ngIf="!isProcessingDifference && !isProcessing && initialArticleContent && changedArticleContent">
  <div
    class="flex items-center justify-between px-6 py-4 space-x-4 border rounded border-project-3500 bg-project-3400/40 text-project-3500"
  >
    <div class="flex flex-col flex-1 space-y-1">
      <h3
        class="text-base font-bold brightness-75"
        data-testid="status-card-title"
      >
        This content has been updated by user
        {{ initialArticleContent.lastUpdatedByUser }} since you last loaded it.
      </h3>
      <div class="flex space-x-3 text-sm italic text-inherit brightness-75">
        <span>
          This can occur when two people are working on the same content, or if
          you open and save the article in multiple tabs.</span
        >
      </div>
    </div>
  </div>

  <div class="flex gap-6 mt-6">
    <div class="space-y-4 basis-1/2">
      <h4 class="text-lg font-bold">Your version (not saved)</h4>
      <div class="flex w-full gap-2 pt-6">
        <button
          mat-button
          type="submit"
          (click)="performArticleSave(changedContentForm)"
          class="w-full h-8 text-xs font-semibold text-white bg-project-2100 disabled:opacity-50 hover:text-project-300"
          mat-raised-button
        >
          Save this version and overwrite
        </button>
        <button
          mat-button
          type="button"
          (click)="setChangedContentMergingMode()"
          class="w-full h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
          mat-raised-button
        >
          {{
            !isChangedContentMergingMode
              ? "Merge into this version"
              : "Cancel merge"
          }}
        </button>
      </div>

      <div class="mt-4 space-y-4">
        <div
          *ngFor="
            let changedContent of changedContentToCompare;
            let index = index
          "
        >
          <div
            *ngIf="changedContent.isStandalone"
            [ngClass]="{
              'outline-project-3400 outline outline-1 outline-offset-2':
                changedContent.text.value !==
                initialContentToCompare[index].text.value
            }"
          >
            <ng-container
              *ngComponentOutlet="
                changedContent.component;
                injector: changedContent.injector
              "
            />
          </div>
          <div
            *ngIf="!changedContent.isStandalone"
            [ngClass]="{
              'outline-project-3400 outline outline-1 outline-offset-2':
                changedContent.injector ? changedContent.text.value !==
                initialContentToCompare[index].text.value :  changedContent.text !==
                initialContentToCompare[index].text
            }"
          >
            <h3
              class="flex items-center p-3 text-sm text-inherit bg-project-600 text-project-2400"
            >
              {{ changedContent.title }}
            </h3>

            <div
              *ngIf="
                changedContent.component && isChangedContentMergingMode;
                else sectionText
              "
            >
              <ng-container
                *ngComponentOutlet="
                  changedContent.component;
                  injector: changedContent.injector
                "
              />
            </div>
            <ng-template #sectionText>{{
              changedContent.text.value ?? changedContent.text
            }}</ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="space-y-4 basis-1/2">
      <h4 class="text-lg font-bold">
        Version saved by {{ initialArticleContent.lastUpdatedByUser }}
      </h4>
      <span class="text-sm"
        >Version saved:
        {{
          initialArticleContent.lastUpdatedDate | date : "dd/MM/yyyy - HH:mm"
        }}</span
      >
      <div class="flex gap-2">
        <button
          mat-button
          type="submit"
          (click)="performArticleSave(initialContentForm)"
          class="w-full h-8 text-xs font-semibold text-white bg-project-2100 disabled:opacity-50 hover:text-project-300"
          mat-raised-button
        >
          Keep this version and lose your changes
        </button>
        <button
          mat-button
          type="button"
          (click)="setInitialContentMergingMode()"
          class="w-full h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
          mat-raised-button
        >
          {{
            !isInitialContentMergingMode
              ? "Merge into this version"
              : "Cancel merge"
          }}
        </button>
      </div>
      <div class="mt-4 space-y-4">
        <div
          *ngFor="
            let initialContent of initialContentToCompare;
            let index = index
          "
        >
          <div
            *ngIf="initialContent.isStandalone"
            [ngClass]="{
              'outline-project-3400 outline outline-1 outline-offset-2':
                initialContent.text.value !==
                changedContentToCompare[index].text.value
            }"
          >
            <ng-container
              *ngComponentOutlet="
                initialContent.component;
                injector: initialContent.injector
              "
            />
          </div>
          <div
            *ngIf="!initialContent.isStandalone"
            [ngClass]="{
              'outline-project-3400 outline outline-1 outline-offset-2':
                initialContent.injector ? initialContent.text.value !==
                  changedContentToCompare[index].text.value :
                initialContent.text !== changedContentToCompare[index].text
            }"
          >
            <h3
              class="flex items-center p-3 text-sm text-inherit bg-project-600 text-project-2400"
            >
              {{ initialContent.title }}
            </h3>
            <div
              *ngIf="
                initialContent.component && isInitialContentMergingMode;
                else sectionText
              "
            >
              <ng-container
                *ngComponentOutlet="
                  initialContent.component;
                  injector: initialContent.injector
                "
              />
            </div>

            <ng-template #sectionText>{{
              initialContent.text.value ?? initialContent.text
            }}</ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-processing-boundary
  [isProcessing]="isProcessing"
  [processingMsg]="'Loading...'"
>
</app-processing-boundary>
<div
  class="p-4"
  *ngIf="!isProcessingDifference && !isProcessing && (!initialArticleContent || !changedArticleContent)"
>
  Error: the change conflict screen cannot be loaded directly. Go to the
  <a [routerLink]="['../edit']">article detail screen instead.</a>
</div>
